import { Link, useLocation } from 'react-router-dom';
import { useMenuToggle } from '@hooks/useMenuToggle';
import { unitsContent } from '@/data/unitsContent';
import styles from './Navigation.module.css';

interface NavigationProps {
  className?: string;
  isMobile?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({ className = '', isMobile = false }) => {
  const location = useLocation();
  const { close } = useMenuToggle();

  const isActive = (path: string) => location.pathname === path;
  const isInTools =
    location.pathname === '/herramientas-online' ||
    location.pathname === '/calculadora-heredabilidad' ||
    location.pathname === '/simulador-seleccion' ||
    location.pathname === '/calculadora-endocria' ||
    location.pathname === '/estimador-heterosis' ||
    location.pathname === '/disenador-experimentos' ||
    location.pathname === '/convertidor-unidades';

  const handleLinkClick = () => {
    if (isMobile) {
      close();
    }
  };

  return (
    <nav className={`${styles.nav} ${className}`}>
      <h2 className={styles.navTitle}>📚 Contenidos</h2>
      <hr className={styles.navDivider} />
      <ul className={styles.navList}>
        <li className={styles.navItem}>
          <Link
            to="/"
            className={`${styles.navLink} ${isActive('/') ? styles.active : ''}`}
            onClick={handleLinkClick}
          >
            Inicio
          </Link>
          <ul className={styles.submenu}>
            <li>
              <Link
                to="/herramientas-online"
                className={`${styles.submenuLink} ${isInTools ? styles.active : ''}`}
                onClick={handleLinkClick}
              >
                Herramientas Online
              </Link>
              <ul className={styles.submenuNested}>
                <li>
                  <Link
                    to="/calculadora-heredabilidad"
                    className={`${styles.submenuNestedLink} ${isActive('/calculadora-heredabilidad') ? styles.active : ''}`}
                    onClick={handleLinkClick}
                  >
                    Calculadora de Heredabilidad
                  </Link>
                </li>
                <li>
                  <Link
                    to="/simulador-seleccion"
                    className={`${styles.submenuNestedLink} ${isActive('/simulador-seleccion') ? styles.active : ''}`}
                    onClick={handleLinkClick}
                  >
                    Simulador de Seleccion
                  </Link>
                </li>
                <li>
                  <Link
                    to="/calculadora-endocria"
                    className={`${styles.submenuNestedLink} ${isActive('/calculadora-endocria') ? styles.active : ''}`}
                    onClick={handleLinkClick}
                  >
                    Calculadora de Endocria
                  </Link>
                </li>
                <li>
                  <Link
                    to="/estimador-heterosis"
                    className={`${styles.submenuNestedLink} ${isActive('/estimador-heterosis') ? styles.active : ''}`}
                    onClick={handleLinkClick}
                  >
                    Estimador de Heterosis
                  </Link>
                </li>
                <li>
                  <Link
                    to="/disenador-experimentos"
                    className={`${styles.submenuNestedLink} ${isActive('/disenador-experimentos') ? styles.active : ''}`}
                    onClick={handleLinkClick}
                  >
                    Disenador de Experimentos
                  </Link>
                </li>
                <li>
                  <Link
                    to="/convertidor-unidades"
                    className={`${styles.submenuNestedLink} ${isActive('/convertidor-unidades') ? styles.active : ''}`}
                    onClick={handleLinkClick}
                  >
                    Convertidor de Unidades
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link
                to="/trabajos-practicos"
                className={`${styles.submenuLink} ${isActive('/trabajos-practicos') ? styles.active : ''}`}
                onClick={handleLinkClick}
              >
                Trabajos Prácticos
              </Link>
            </li>
            <li>
              <Link
                to="/proyectos-finales"
                className={`${styles.submenuLink} ${isActive('/proyectos-finales') ? styles.active : ''}`}
                onClick={handleLinkClick}
              >
                Proyectos Finales
              </Link>
            </li>
          </ul>
        </li>

        {unitsContent.map((unit) => (
          <li key={unit.numero} className={styles.navItem}>
            <Link
              to={`/unidad/${unit.numero}`}
              className={`${styles.navLink} ${
                isActive(`/unidad/${unit.numero}`) ? styles.active : ''
              }`}
              onClick={handleLinkClick}
            >
              Unidad {unit.numero}: {unit.titulo}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
